export default __webpack_public_path__ + "static/media/shonit nrbc.27955a5a.png";